import api from "../config/api";

export const getOrganizations = async (data) => {
  const res = await api.get("organizations", data);
  return res.data;
};

export const getOrganizationByid = async (_id) => {
  const res = await api.get(`organizations/${_id}`);
  return res.data;
};
